import React from 'react';
import logo from './logo.svg';
import './App.scss';
import LightStateRow from './LightStateRow';
import Pusher from 'pusher-js';
import LightDiagram from './LightDiagram';
class App extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      lights: props.lightState || [],
      fetchState: 'idle'
    }
    this.circuitToggled = this.circuitToggled.bind(this)
    this.attemptStateRead = this.attemptStateRead.bind(this)
    this.fetchTimer = null
    this.messageArrived = this.messageArrived.bind(this)
  }

  startPusher() {
    Pusher.logToConsole = true;
    this.pusher =  new Pusher('3885b4a37adc34f0c3e2', {
      cluster: 'mt1'
    });
    var channel = this.pusher.subscribe('lights-status');
    channel.bind('lights-status-update', (data) => {
      this.messageArrived(data)
      this.setState(data)
    });
  }

  messageArrived(data) {
    console.log('Message arrived', data.lights)
    console.table(data.lights)
  }
  componentDidMount(){
    this.readState()
    this.startPusher()
  }

  attemptStateRead() {
    console.log('Trying to read')
  
    console.log('Reading')
    this.readState()
    
  }

  componentWillUnmount() {
    this.pusher.disconnect();
  }
  circuitToggled(name, newValue) {
    const lightStates = this.state.lights
    console.log('App Circuit Toggled', name, newValue)
    for(let ls of lightStates) {
      if(ls.name === name) {
        console.log('LS found', ls)
        ls.value = newValue
      }
    }
    const newState = {lights: lightStates}
    
    this.sendState(newState)
  }

  sendState(state) {
    //this.setState({fetchState: 'writing'})
    // const stateString = JSON.stringify(newState)
    // console.log('LPUSH', stateString)
    // this.client.lpush('LIGHT-STATES', stateString)
    //this.pusher.send_event('lights-status-update', state)
  
    console.log(JSON.stringify(state))
    fetch("https://people-sync.herokuapp.com/lightstate", {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: "POST", 
        body: JSON.stringify(state)
      }).then(res => {
        console.log("Request complete! response:", res);
        //this.readState()
      });
    
  }

  readState() {
    //this.setState({ fetchState: 'reading'})
    // const stateString = this.client.lindex('LIGHT-STATES', 0)
    fetch('https://people-sync.herokuapp.com/lightstate')
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const newState = data
        //newState['fetchState'] = 'idle'
        this.setState(newState)
      });
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className={`App-logo ${this.state.fetchState}`} alt="logo" />
          <h1 className="App-title">
            <strong>Factoria</strong>Lights
          </h1>
        </header>
        <main>
          <LightStateRow lightStates={this.state.lights} onChange={this.circuitToggled}/>
          <LightDiagram lights={this.state.lights} />
        </main>
      </div>
    );
  }
}


export default App;
